import { Group, GroupTitle, useDebounce } from "ra-friendsofbabba";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, useFormState } from "react-final-form";

import CannotViewField from "../fields/CannotViewField";
import { FormHelperText } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { get } from "lodash";
import { replaceAllMulti } from "../../utils/String";
import { useInput } from "react-admin";
import usePrivileges from "../usePrivileges";
import { useRef } from "react";
import { useTranslate } from "ra-core";

const TextItemInput = ({
  bind,
  evalItems,
  minLength = 200,
  maxLength = 1000,
  disabled,
  source,
  final = false,
  ...props
}) => {
  const form = useForm();
  const formState = useFormState();
  const translate = useTranslate();
  const {
    input: { name, ...rest },
    meta: { touched, valid, error, submitError },
    isRequired,
  } = useInput({ ...props, source });
  const { item, value, validationError, contentLabel } = useMemo(() => {
    const contentLabel = translate(`app.label.content`);
    const items = evalItems.filter((ei) => ei.group === bind);
    const item = get(items, "0", {
      id: 0,
      name: bind,
      help: undefined,
    });
    const filledItems = get(formState.values, source, []);
    const match = filledItems.find((fi) => fi.eval_item_id === item.id);
    const index = item.id - 1;
    let value = get(match, "value", "");
    if (value === null) {
      value = "";
    }
    const validationError = get(submitError, `${index}.value`, error);
    return {
      item,
      items,
      index,
      contentLabel,
      value,
      validationError,
    };
  }, [
    evalItems,
    bind,
    formState.values,
    source,
    error,
    submitError,
    translate,
  ]);
  const [text, setText] = useState(value);
  const debouncedText = useDebounce(text, 500);
  const handleChange = useCallback((e) => setText(e.target.value), []);
  const didMount = useRef(false);
  // useEffect(() => setText(value), [value]);
  useEffect(
    () => {
      if (didMount.current === false) {
        didMount.current = true;
        return;
      }
      const filledItems = get(formState.values, source, []);
      const target = filledItems.find((fi) => fi.eval_item_id === item.id);

      target.value = debouncedText;

      form.change(source, [...filledItems]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedText]
  );

  const usedCharsInfo = translate("app.input.min_max_length_info", {
    count: get(text, "length", 0),
    min: minLength,
    max: maxLength,
  });
  const { canView } = usePrivileges({ ...props });
  const { title, subTitle } = useMemo(() => {
    const words = ["e finali", "finale", "finali", "del triennio"];
    const repls = ["", "", "", "del periodo"];
    const title = replaceAllMulti(
      item?.name?.toUpperCase(),
      !final ? words : [],
      !final ? repls : []
    );
    const subTitle = replaceAllMulti(
      item?.help,
      !final ? words : [],
      !final ? repls : []
    );
    return {
      title,
      subTitle,
    };
  }, [item.name, item.help, final]);
  if (item.id === 0) {
    return null;
  }
  if (!canView) {
    return <CannotViewField {...props} bind={bind} source={source} />;
  }

  return (
    <Group wrapper>
      <GroupTitle title={title} subTitle={subTitle} />
      <TextField
        {...rest}
        disabled={disabled}
        variant="filled"
        name={name}
        label={contentLabel}
        error={!!(touched && validationError)}
        helperText={!valid && validationError}
        required={isRequired}
        fullWidth
        value={text}
        onChange={handleChange}
        multiline
        inputProps={{
          maxLength,
        }}
      />
      <FormHelperText>{usedCharsInfo}</FormHelperText>
    </Group>
  );
};

export default TextItemInput;
